import React, { Component } from "react";
import LoaderButton         from "../components/LoaderButton";
import { AccountDemo }      from "../utils/StaticIds";
import { WhiteLabel }       from "../utils/WhiteLabelProps";

import "../css/PanelMeasureAddSubtract.css";

var timeout = null;

var white_label = WhiteLabel();
const MainColor = white_label.company_primary_btn_color;

const CursorStart = 0;
const CursorEnd   = 3;
var   tour_ctr    = 0;
export default class PanelMeasureAddSubtract extends Component {

    constructor(props) {
        super(props)
        var measure_a_value = this.props.measure_a_value;
        var measure_b_value = this.props.measure_b_value;

        if(measure_a_value === "") measure_a_value = 0;
        this.state = {
            isLoading: false,
            displayOverlay:  "none",
            athlete_id:      this.props.athlete_id,
            block_id:        this.props.block_id,
            set_id:          this.props.set_id,
            set_number:      this.props.panel_ctr,
            exercise_id:     this.props.exercise_id,
            measure_id:      this.props.measure_id,
            measure_a_value: measure_a_value,
            measure_b_value: this.props.measure_b_value,
            measure_a_id:    this.props.measure_a_id,
            measure_b_id:    this.props.measure_b_id,
            psmv_id:         this.props.psmv_id,
            measure_c_value: this.props.measure_c_value,
            measure_rest:    this.props.measure_rest,
            panel_group_ctr: this.props.panel_group_ctr // used in "All Metrics" screen
        }
    }

    handleDecreaseMetricA = () => {
        var measure_a_value = this.state.measure_a_value;
        var panel_group_ctr = this.state.panel_group_ctr;

        if(measure_a_value > 0) {
            var new_val = parseInt(this.state.measure_a_value) - 1;
            this.setState({measure_a_value: new_val});
        }
        this.props.changeMetricValue(this.state.set_number, new_val, this.state.measure_b_value, panel_group_ctr);
    }

    handleIncreaseMetricA = () => {
        var new_val = parseInt(this.state.measure_a_value) + 1;
        var panel_group_ctr = this.state.panel_group_ctr;

        this.setState({measure_a_value: new_val});
        this.props.changeMetricValue(this.state.set_number, new_val, this.state.measure_b_value, panel_group_ctr);
    }

    handleIncreaseMetricB = () => {
        var new_val = parseInt(this.state.measure_b_value) + 1;
        var panel_group_ctr = this.state.panel_group_ctr;


        this.setState({measure_b_value: new_val});
        this.props.changeMetricValue(this.state.set_number, this.state.measure_a_value, new_val, panel_group_ctr);
    }

    handleDecreaseMetricB = () => {
        var measure_b_value = this.state.measure_b_value;
        var panel_group_ctr = this.state.panel_group_ctr;

        if(measure_b_value > 0) {
            var new_val = parseInt(measure_b_value) - 1;
            this.setState({measure_b_value: new_val});
            this.props.changeMetricValue(this.state.set_number, this.state.measure_a_value, new_val, panel_group_ctr);
        }
    }

    handleChangeFocusTextfieldA = event => {
        var measure_a_value = this.state.measure_a_value;
        if(measure_a_value === 0) this.setState({measure_a_value: ""});

        event.target.setSelectionRange(CursorStart, CursorEnd);
    }

    handleChangeFocusTextfieldB = event => {
        var measure_b_value = this.state.measure_b_value;
        if(measure_b_value === 0) this.setState({measure_b_value: ""});

        event.target.setSelectionRange(CursorStart, CursorEnd);
    }

    moveCaretAtEnd(e) {
        var temp_value = e.target.value
        e.target.value = ''
        e.target.value = temp_value
    }

    handleChangeTextfieldA = (event) => {
        var new_val = event.target.value;
        var that = this;
        var set_number = this.state.set_number;
        var measure_b_value = this.state.measure_b_value;
        var panel_group_ctr = this.state.panel_group_ctr;

        // var hms = '02:04:33';   // your input string
        // var a = new_val.split(':'); // split it at the colons
        // minutes are worth 60 seconds. Hours are worth 60 minutes.
        // var measure_a = (Number(a[0]) * 60) + Number(a[1]);

        this.setState({measure_a_value: new_val});

        // Clear the timeout if it has already been set.
        // This will prevent the previous task from executing
        // Using timeout below keeps the keyboard open on a mobile device,
        // otherwise the keyboard just opens and closes immediately after entering a number
        clearTimeout(timeout);

        timeout = setTimeout(function () {
            //console.log("time up");

            that.props.changeMetricValue(set_number, new_val, measure_b_value, panel_group_ctr);
        }, 1500);
    }

    handleChangeTextfieldB = (event) => {
        var new_val = event.target.value;
        var that = this;
        var set_number = this.state.set_number;
        var measure_a_value = this.state.measure_a_value;
        var panel_group_ctr = this.state.panel_group_ctr;
        //if(new_val == "") new_val = 0;

        this.setState({measure_b_value: new_val});
        // Clear the timeout if it has already been set.
        // This will prevent the previous task from executing
        clearTimeout(timeout);

        timeout = setTimeout(function () {
            that.props.changeMetricValue(set_number, measure_a_value, new_val, panel_group_ctr);
        }, 1500);
    }

    handleSubmit = async event => {
        //this.setState({displayOverlay:  "inherit"}) //show overlay

        // Remove timer and thus, the focus on input fields; otherwise newly inputted alues carry over if keyboard
        // is being used while the metric values are saved (ie while the timer is still counting down)
        clearTimeout(timeout);

        event.preventDefault();
        var panel_group_ctr = this.state.panel_group_ctr;
        var block_id    = this.state.block_id;
        var set_id      = this.state.set_id;
        var exercise_id = this.state.exercise_id;
        var measure_id  = this.state.measure_id;
        var metric_a    = this.state.measure_a_value;
        var metric_b    = this.state.measure_b_value;
        var metric_a_id = this.state.measure_a_id;
        var metric_b_id = this.state.measure_b_id;
        var set_number  = this.state.set_number+1;
        var psmv_id     = this.state.psmv_id;
        var block_id    = this.state.block_id;

        this.props.saveSingleSetMetricData(set_id, exercise_id, set_number, measure_id, metric_a, metric_b, metric_a_id, metric_b_id, psmv_id, panel_group_ctr, block_id);
    }


    render() {

        var measure_2_title = this.props.measure_2_title.toUpperCase();
        var measure_3_title = "";
        var overlay         = this.state.displayOverlay;
        var athlete_id      = this.state.athlete_id;

        var block_number    = this.props.blockNumber;
        var exercise_number = this.props.exerciseNumber;
        var exercise_total  = this.props.exercisesTotal;

        if(this.props.measure_3_title != undefined)
            measure_3_title = this.props.measure_3_title.toUpperCase();

        if(AccountDemo === athlete_id) {
            // disable the panel entirely
            overlay = "inline"
        }
        // Product Tour Classes //
        var decreaseClassName  = "glyphicon glyphicon-minus panelMeasureMinus not-selectable";
        var textfieldClassName = "pamelMeasureAText";
        if(tour_ctr === 0) {
            decreaseClassName  = "glyphicon glyphicon-minus panelMeasureMinus not-selectable workoutDetailPanelSubtractProductTour";
            textfieldClassName = "pamelMeasureAText workoutDetailPanelTextfieldProductTour";
        }

        tour_ctr = 1;
        var hide_panel_text = "visible";
        if(block_number == undefined && exercise_number == undefined) hide_panel_text = "hidden"

        return (
            <div className="panelMeasureBody">
                <span className = {decreaseClassName}
                      style={{color: MainColor}}
                      onClick={() => this.handleDecreaseMetricA()} />
                <span className={textfieldClassName}>
                    <input type      = "tel"
                           ref       = "pamelMeasureA_tf"
                           className = "panelMeasureTextfield"
                           maxLength = "3"
                           onFocus   = {(e) => this.handleChangeFocusTextfieldA(e)}
                           value     = {this.state.measure_a_value}
                           onChange  = {this.handleChangeTextfieldA} />
                </span>
                <span onClick={() => this.handleIncreaseMetricA()}>
                        <span className="glyphicon glyphicon-plus panelMeasurePlus not-selectable"
                              style={{color: MainColor}} />
                </span>
                <div className="panelMeasureAField">
                    { measure_2_title }
                </div>
                <div className="panelMeasureX">
                    <img src={require('../images/utils/measure_circle_x.png')} width="26"/>
                </div>


                <span className = { decreaseClassName }
                      onClick   = {() => this.handleDecreaseMetricB()}
                      style     = {{color: MainColor}} />
                <span className={textfieldClassName}>
                    <input type      = "tel"
                           ref       = "pamelMeasureB_tf"
                           className = "panelMeasureTextfield"
                           maxLength = "3"
                           //ref={(input) => this.text = input}
                           onFocus   = {(e) => this.handleChangeFocusTextfieldB(e)}
                           value     = {this.state.measure_b_value}
                           onChange  = {this.handleChangeTextfieldB} />
                </span>
                <span onClick={() => this.handleIncreaseMetricB()}>
                        <span className="glyphicon glyphicon-plus panelMeasurePlus not-selectable workoutDetailPanelAddProductTour"
                              style={{color: MainColor}}/>
                </span>

                <div className="panelMeasureAField">
                    { measure_3_title }
                </div>

                    { /*}<span className="panelMeasureSubTitleA">% of Max: {this.state.measure_c_value} </span>*/ }
                <span className="panelMeasureSubTitleB">Rest: {this.state.measure_rest} </span>

                <div className="panelMeasureLoaderBtnBox" style={{}}>

                    <form onSubmit={this.handleSubmit}>
                            <LoaderButton
                                className = "workoutDetailPanelSaveBtnProductTour"
                                bsSize   = "large"
                                height   = "38px"
                                width    = "220px"
                                fontSize = "17px"
                                type     = "submit"
                                btncolor = { MainColor }
                                isLoading= {this.state.isLoading}
                                text     = "SAVE"
                                loadingText="Saving …"
                              />
                     </form>
                     <br/><br/>
                     <div className="panelMeasureBlockStatus" style={{visibility: hide_panel_text}}>
                         Block {block_number}: <b style={{color:"#333"}}>Exercise {exercise_number}</b> of {exercise_total}
                     </div>

                </div>

                <span className="panelAddSubtractOverlay" style={{display: overlay}}></span>
            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./src/components/PanelMeasureAddSubtract.js